import { getCsrfValue } from "~/common/utils/ApiHelper";
import { getOccTransport } from "~/common/api/occTransport";

export const updateSalesPartner = (subsidiaryId: string, cartId: string, userPath: string) => {
  const { request, baseSiteUrl } = getOccTransport();
  const apiUrl = baseSiteUrl(`${userPath}/carts/${encodeURIComponent(cartId)}/sales-partner`);

  return request(
    apiUrl,
    {
      body: JSON.stringify(subsidiaryId),
      credentials: "same-origin",
      mode: "cors",
      referrer: "no-referrer",
      method: "PATCH",
      headers: {
        "content-type": "application/json",
        CSRFToken: getCsrfValue(),
      },
    },
    { accountContext: "omit" },
  ).then((response) => {
    if (!response.ok) {
      throw alert("Error status: " + response.status + ", please try again");
    } else {
      return response;
    }
  });
};
